var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDanger = function SvgDanger(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.2 23.08",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e13030;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_5721"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.44,22.76c-.55,0-1.09-.15-1.56-.43-.74-.43-1.26-1.11-1.48-1.93-.22-.82-.11-1.68.32-2.41L10.38,1.86s0,0,0,0c.26-.44.63-.81,1.07-1.07,1.5-.91,3.46-.43,4.37,1.07l9.66,16.13c.28.48.43,1.02.43,1.57.02,1.75-1.39,3.2-3.15,3.21H3.44ZM11.92,2.78h0S2.26,18.9,2.26,18.9c-.18.31-.23.68-.13,1.03.1.36.32.65.64.84.21.12.44.18.67.18h19.31c.75,0,1.36-.63,1.36-1.4,0-.24-.07-.47-.19-.67L14.28,2.78c-.39-.65-1.24-.85-1.89-.46-.19.11-.35.27-.46.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_5722"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.1,13.64c-.5,0-.9-.4-.9-.9v-4.56c0-.5.4-.9.9-.9s.9.4.9.9v4.56c0,.5-.4.9-.9.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_5723"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.1,18.2c-.24,0-.47-.09-.64-.26-.17-.17-.26-.4-.26-.64s.09-.47.26-.63c.25-.26.65-.34.98-.2.11.05.21.11.29.2.17.16.27.4.27.63s-.1.47-.27.64c-.08.08-.18.15-.29.19-.11.05-.22.07-.34.07Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDanger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "danger.d13b4f1b597aeccccb7bb242a9f60c44.svg";